import isAuthComponentAvailable from './is-auth-component-available';

export default {
  isAuthComponentAvailable,
};
